// Bundle Builder JS file
$(document).ready(function() {
  const $modalWidget = $('.bundle-builder-widget');
  let firstLevelDiscountOut = false;
  let disableDiscount = false;

  if ($modalWidget.data('first-level-no-discount')) {
    firstLevelDiscountOut = true;
  }

  if ($modalWidget.data('disable-discount')) {
    disableDiscount = true;
  }

   // Open the modal
   $(document).on('click', '[data-bundle-widget-open]', (e) => {
    $('.bundle-builder-widget').show();
    const isDiscountTimer = checkDiscountTimer();

    $("html").addClass("no-scroll");

    if(!isStepZero()) {
      // Check people account, and disable continue button
      const optionInputs = $modalWidget.find('.bundle-builder-input');
      let all_empty = true;
      Array.from(optionInputs).forEach(element => {
        if($(element).val() > 0 ) all_empty = false;
      })

      if(all_empty) {
        $modalWidget.find('.button--next').addClass('disabled');
      }else{
        $modalWidget.find('.button--next').removeClass('disabled');
      }
    }else{
      $modalWidget.find('.button--next').addClass('hide');
    }

   })

  // Close the modal
  $(document).on('click', '[data-bundle-widget-close]', (e) => {
    $('.bundle-builder-widget').hide();
    $("html").removeClass("no-scroll");
  })


  // Title Array
  const titleArr = {
    'family': 'Who will be doing this study?',
    'topic': 'What would you like to study?',
    'topic-restart': 'What else would you like to study?',
    'studies': 'Your personalized study bundle',
    'upgrades': 'Grab these for extra fun as you GROW',
    'review': 'Your Contentment Bundle',
    'finish': 'Your bundle was added to cart!'
  }

  // Title Array
  let subTitleArr = {
    'family': 'Select the number of participants in each age group:',
    'studies': "To get the most out of your study, you'll want 1 book per family member. Buy more, save more!",
    'upgrades': 'Get an extra 10% off!',
    'empty_cart': 'You don’t have any items in your bundle.'
  }

  if (disableDiscount) {
    subTitleArr = {
      'family': 'Select the number of participants in each age group:',
      'studies': "To get the most out of your study, you'll want 1 book per family member. Buy more, save more!",
      'upgrades': '',
      'empty_cart': 'You don’t have any items in your bundle.'
    }
  }


  //Message Array
  const messageArr = {
    'family': '',
    'studies': '',
    'upgrades': 'Just click on these fun extras to add them to your bundle!',
    'review': '',
    'empty_cart': ''
  }

  // Selected Product Handle
  let selectedProductHandle = '';
  let selectedAddonHandles = [];
  let selectedVariantOptions = [];

  let selectedProductInfo = [];

  // Check if bundle model has discount timer enabled.
  const checkDiscountTimer = () => {
    const c_date = new Date();
    const c_timestamp = c_date.getTime();
    const start_time_day = $modalWidget.data('discount-start-day');
    const start_time_month = $modalWidget.data('discount-start-month');
    const start_time_year = $modalWidget.data('discount-start-year');
    const end_time_day = $modalWidget.data('discount-end-day');
    const end_time_month = $modalWidget.data('discount-end-month');
    const end_time_year = $modalWidget.data('discount-end-year');


    const start_time = new Date(start_time_year, start_time_month, start_time_day, 00, 00, 00);
    const end_time = new Date(end_time_year, end_time_month, end_time_day, 23, 59, 59);

    if(c_timestamp >= start_time.getTime() && c_timestamp <= end_time.getTime()){
      return true;
    }
    return false;
  }

  //Save all the selected options of Step 1 into a global varible
  const saveSelectedOptions = () => {
    selectedVariantOptions = [];
    const memberTypes = $('.member__profile');
    Array.from(memberTypes).forEach(element => {
      const type = $(element).data('type');
      const count = $(element).find('.bundle-builder-input').val();
      for(var i = 0; i < count; i++) {
        selectedVariantOptions.push(type)
      }
    })
  }

  //Save the product handle and addon handle on Step 2 into a global variable
  const saveSelectedBundleHandle = () => {
    selectedProductHandle = '';
    selectedAddonHandles = [];

    const bundlesWrapper = $('.modal__step--zero .product__container.selected');
    if(!bundlesWrapper || bundlesWrapper.length < 1) return false;

    Array.from(bundlesWrapper).forEach(element => {
      selectedProductHandle = $(element).data('product-handle');
      let addon_str = $(element).data('addon');

      if(addon_str) {
        addon_str =  addon_str.replace(/\s/g,'');
        selectedAddonHandles = addon_str.split(',');
      }
    })

    return true;
  }

   //Save all the selected Product Info of Step 2 into a global varible
   const saveSelectedProductInfo = () => {
    selectedProductInfo = [];

    const productsWrapper = $('.modal__step--two .product__thumbnail.selected');
    if(!productsWrapper || productsWrapper.length < 1){
      $modalWidget.find('.overlay').hide();
      return false;
    }
    let products = [];

    Array.from(productsWrapper).forEach(element => {
      const productId = $(element).data('product-id');
      const variantId = $(element).data('id');
      const imgSrc = $(element).data('img');
      const price = $(element).data('price');
      const title = $(element).data('title');
      const variantOptionName = $(element).data('value');

      let current_qty = 0;
      selectedVariantOptions.forEach(selectedVariantOption => {
        if(variantOptionName.includes(selectedVariantOption)){
          current_qty++;
        }
      });

      const variantInfo = {
        'qty': current_qty,
        'id': variantId,
        'addOn': false,
        'product_id': productId,
        'title': title,
        'price': price,
        'img': imgSrc
      };
      products.push(variantInfo);
    });

    selectedProductInfo = [...products];
    return true;
  }

  const saveSelectedAddonInfo = () => {
    //Clean added add ons
    const clearAddon = selectedProductInfo.filter(function(v) { return !v.addOn; });
    selectedProductInfo = [...clearAddon];

    const productsWrapper = $('.modal__step--three .product__thumbnail.selected');

    Array.from(productsWrapper).forEach(element => {
      const variantId = $(element).data('variant-id');
      const imgSrc = $(element).data('img');
      const price = $(element).data('price');
      const title = $(element).data('title');

      let current_qty = 1;
      const addOnInfo = {
        'qty': current_qty,
        'id': variantId,
        'addOn': true,
        'title': title,
        'price': price,
        'img': imgSrc
      };
      selectedProductInfo.push(addOnInfo);
    });
  }

  // Update cart items, re-render cart items
  const updateQuantity = (variantId, nextVal) => {
    const tempSelectedProductInfo = [...selectedProductInfo];
    const updatedResult = tempSelectedProductInfo.map(item => {
      var temp = Object.assign({}, item);
      if (temp.id === variantId) {
          temp.qty = nextVal;
      }
      return temp;
    });
    const filteredResultByQty = updatedResult.filter(function(v) { return v.qty > 0; });
    selectedProductInfo = [];
    selectedProductInfo = [...filteredResultByQty];
    setTimeout(function(){
      renderCartItems();
    }, 0);
  }

  // Get discount value
  const calMainDiscount = (count) => {
    if (!firstLevelDiscountOut || !disableDiscount) {
      if (count >=2 && count < 4) {
        return 0.9;
      } else if (count >=4) {
        return 0.80;
      } else {
        return 1;
      }
    }
  }

  const newBundleId = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  const variantsToAdd = () => {

    let bundlePlaceholderSet = false;
    const bundleId = newBundleId();
    const boxId = newBundleId();
    const bundleQty = 1;
    const reversedSelectedProductInfo = [...selectedProductInfo].reverse()
    const returnData = reversedSelectedProductInfo.map(function(v) {
      var bundleDiscount = 0;

      var itemProperty = {};
      const isDiscountTimer = checkDiscountTimer();
      itemProperty['_boxId'] = boxId;
      itemProperty['_bundle_initial_qty'] = v.qty;

      const hasMain = selectedProductInfo.find(item => !item.addOn );
      if(!hasMain) {
        if(!bundlePlaceholderSet) {
          const bundle_title = $modalWidget.find('.modal__step--zero .product__container.selected h4').text();
          if(bundle_title) itemProperty['_bundle_title'] = bundle_title;
          bundlePlaceholderSet = true;
        }
      }else{
        if (!v.addOn) {
          if(!bundlePlaceholderSet) {
            const bundle_title = $modalWidget.find('.modal__step--zero .product__container.selected h4').text();
            if(bundle_title) itemProperty['_bundle_title'] = bundle_title;
            bundlePlaceholderSet = true;
          }
        }
      }

      if(!isDiscountTimer) {
        itemProperty['_bundle'] = bundleId;

        if (v.addOn) {
          if (!disableDiscount) {
            itemProperty['_bundle:addon'] = true;
          }

        }
        else {
          if (!firstLevelDiscountOut && !disableDiscount) {
            itemProperty['_bundle:main'] = v.product_id;
          }
        }
      }


      return {
        quantity: v.qty,
        variant_id: v.id,
        properties: itemProperty
      };
    });
    return returnData;
  }

  const addItemsToCart = (items) => {
    const formData = {
      items: items.map(item => ({
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties
      }))
    };

    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(formData),
        contentType: 'application/json',
        success: function(response) {
          resolve(response);
        },
        error: function(error) {
          reject(error);
        }
      });
    });
  }

  const addBundleToCart = () => {
    const variantsJSON = variantsToAdd();
    addItemsToCart(variantsJSON).then(function(response) {

      window.PXUTheme.asyncView.load(window.PXUTheme.routes.cart_url, // template name
        'ajax' // view name (suffix)
      ).done(function (_ref3) {
        var html = _ref3.html,
            options = _ref3.options;

        if (options.item_count > 0) {
          var cartList = $(html.content).find('.ajax-cart__list');
          var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
          $('.ajax-cart__list').replaceWith(cartList);
          $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
          $('.ajax-cart__empty-cart-message').addClass('is-hidden');
          $('.ajax-cart__form').removeClass('is-hidden');
          $('[data-ajax-cart-trigger]').addClass('has-cart-count');
          $('[data-bind="itemCount"]').text(options.item_count);
          $modalWidget.find('.overlay').hide();
        } else {
          $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
          $('.ajax-cart__form').addClass('is-hidden');
          $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
          $('[data-bind="itemCount"]').text('0');
          $modalWidget.find('.overlay').hide();
        }

        //Go to the Onboarding page.
        const activeStep = getActiveStep();
        // const nextActiveStep = activeStep.next('.stepper-item');
        // if(!nextActiveStep || nextActiveStep.length == 0) return;

        const nextStepData = "topic-restart"
        const nextActiveBody = $(`.modal__step[data-step=${nextStepData}]`);
        nextActiveBody.addClass('active');
        $('.bundle-builder-widget').removeClass('four');
        activeStep.addClass('completed');
        $('.stepper-wrapper .stepper-item').removeClass('active');
        $('.modal__body .modal__step').removeClass('active');

        $modalWidget.find('.modal__header .modal__step').hide();
        $modalWidget.find('.modal__title h2').text(getActiveTitle('topic-restart'));
        $modalWidget.find('.modal__title p').text('');
        $modalWidget.find('.modal__step--zero').addClass('active');
        $modalWidget.find('.modal__step--zero').removeClass('hide');
        $modalWidget.find('.modal__step--zero .product__container').removeClass('selected')

        // nextActiveStep.addClass('active');

        $('.modal__action-buttons .button--back').addClass('hide')
        $('.modal__action-buttons .button-bundle-widget-addtocart').addClass('hide');
        $('.modal__action-buttons .button--continue-shopping').removeClass('hide')

        if (!firstLevelDiscountOut) {
          $('.bundle-builder-widget .cart__footer .saved-text').text('');
        }

        $('.bundle-builder-widget .cart__footer .total-price').text('');

        if (Currency.show_multiple_currencies) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }
      }).fail(function () {// some error handling
        $modalWidget.find('.overlay').hide();
      });

      $modalWidget.find('.overlay').hide();
    }).catch((reason) => {
        $modalWidget.find('.overlay').hide();
    });

  }

  // Return active title String
  const getActiveTitle = (step) => {
    return titleArr[step];
  }
  // Return active Sub title String
  const getActiveSubTitle = (step) => {
    return subTitleArr[step];
  }

  //Return active message
  const getActiveMessage = (step) => {
    return messageArr[step];
  }

  // Get Current Active Step
  const getActiveStep = () => {
    return $('.stepper-wrapper .stepper-item.active');
  }

  // Get Current Active Body
  const getActiveBody = () => {
    return $('.modal__body .modal__step.active');
  }

  const isStepZero = () => {
    return !$modalWidget.find('.modal__step--zero').hasClass('hide');
  }

  // Go to the first init
  const goToInit = () => {
    selectedAddonHandles = [];
    selectedVariantOptions = [];
    selectedProductInfo = [];

    $('.stepper-wrapper .stepper-item').removeClass('completed');
    $('.stepper-wrapper .stepper-item').removeClass('active');
    $('.modal__body .modal__step').removeClass('active');

    $('.stepper-wrapper .stepper-item[data-step="family"]').addClass('completed');

    const nextStepData = 'family'
    const nextActiveStep = $(`.stepper-wrapper .stepper-item[data-step=${nextStepData}]`);
    const nextActiveBody = $(`.modal__step[data-step=${nextStepData}]`);

    $('.modal__title h2').text(getActiveTitle(nextStepData));
    $('.modal__title p').text(getActiveSubTitle(nextStepData));
    $('.modal__title span').text(getActiveMessage(nextStepData));
    nextActiveStep.addClass('active');
    nextActiveBody.addClass('active');

    $('.modal__action-buttons .button--back').removeClass('hide')
    $('.modal__action-buttons .button--next').removeClass('hide')
  }

  // Get Product JSON
  const getProductJSON = (handle) => {
    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'GET',
        url: `/products/${handle}.js`,
        dataType: 'json',
        success: function(data) {
          resolve(data);
        },
        error: function(error) {
          reject(error);
          $modalWidget.find('.overlay').hide();
        }
      });
    });
  };

  //Add to Cart button Click event
  $('.button-bundle-widget-addtocart').on('click', (e) => {
    $modalWidget.find('.overlay').show();
    addBundleToCart();
  })

  // Modal Footer Action Buttons Start
  $('.modal__action-buttons .button--next').on('click', (e) => {

    const activeStep = getActiveStep();
    const activeBody = getActiveBody();
    const nextActiveStep = activeStep.next('.stepper-item');
    if(!nextActiveStep || nextActiveStep.length == 0) return;

    const nextStepData = nextActiveStep.data('step');

    if(nextStepData == 'studies') {
      $modalWidget.find('.overlay').show();
      $('.modal__action-buttons .button--back').removeClass('hide')
      saveSelectedOptions();
      const savedBundle = saveSelectedBundleHandle();

      // if(!savedBundle) {
      //   alert('You need to select at least one item!');
      //   return;
      // }
      $('.modal__step--two').html('');
      const productJSON = getProductJSON(selectedProductHandle)
        .then(function(response) {
          if(response){
            try {
              renderProducts(response);
            } catch (error) {
              $modalWidget.find('.overlay').hide();
            }

          }else{
            $modalWidget.find('.overlay').hide();
          }
        })
    }

    if(nextStepData == 'upgrades') {
      $modalWidget.find('.overlay').show();
      //Save selected product's variant ID and option1's name
      const productSaved = saveSelectedProductInfo();
      if(!productSaved) {
        alert('You need to select at least one product!');
        $modalWidget.find('.overlay').hide();
        return;
      }

      //Rendering Add ons
      const addons = Promise.all(
        selectedAddonHandles.map(async handle => {
          let res = await getProductJSON(handle)
          return res;
        })
      ).then((addons) => {
        renderAddons(addons);
      }).catch((reason) => {
          $modalWidget.find('.overlay').hide();
      });

      $('.modal__title span').text(getActiveMessage(nextStepData));
    }

    if(nextStepData == 'review'){
      $modalWidget.find('.overlay').show();
      //save selected variants
      saveSelectedAddonInfo();
      $('.bundle-builder-widget').addClass('four');
      //Rendering cart view
      renderCartItems();
      $('.modal__action-buttons .button--next').addClass('hide');
      $('.modal__action-buttons .button-bundle-widget-addtocart').removeClass('hide');
      $modalWidget.find('.cart__headings').removeClass('hide');
      $modalWidget.find('.modal__title p').removeClass('hide');
      // addBundleToCart();
    }


    // const nextActiveStep = activeStep.next('.stepper-item');
    const nextActiveBody = $(`.modal__step[data-step=${nextStepData}]`);

    activeStep.addClass('completed');
    $('.stepper-wrapper .stepper-item').removeClass('active');
    $('.modal__body .modal__step').removeClass('active');

    if(nextStepData == 'review'){
      const pre_title = $modalWidget.find('.modal__step--zero .product__container.selected h4').text();
      $('.modal__title h2').text(`Your ${pre_title} Bundle`);
    }else{
      $('.modal__title h2').text(getActiveTitle(nextStepData));
    }

    $('.modal__title p').text(getActiveSubTitle(nextStepData));
    if(nextStepData == 'upgrades' && checkDiscountTimer()) {
      $('.modal__title p').text('');
    }

    $('.modal__title span').text(getActiveMessage(nextStepData));

    nextActiveStep.addClass('active');
    nextActiveBody.addClass('active');
  })

  $('.modal__action-buttons .button--back').on('click', (e) => {
    const activeStep = getActiveStep();
    const prevActiveStep = activeStep.prev('.stepper-item');
    if(!prevActiveStep || prevActiveStep.length == 0)  return;

    const prevStepData = prevActiveStep.data('step');

    if(prevStepData == 'upgrades' && selectedProductInfo.length < 1) {
      goToInit();
      return;
    }

    const prevActiveBody = $(`.modal__step[data-step=${prevStepData}]`);

    $('.stepper-wrapper .stepper-item').removeClass('active');
    $('.modal__body .modal__step').removeClass('active');

    $('.modal__title h2').text(getActiveTitle(prevStepData));
    $('.modal__title p').text(getActiveSubTitle(prevStepData));
    $('.modal__title span').text(getActiveMessage(prevStepData));
    prevActiveStep.addClass('active');
    prevActiveStep.removeClass('completed');
    prevActiveBody.addClass('active');

    if(prevStepData == 'family') {
      const $variantsSlider = $('[data-recommended-variants-slider]');
      if($variantsSlider.hasClass('flickity-enabled')) {
        $variantsSlider.flickity('destroy');
      }
    }

    if(prevStepData == 'upgrades') {
      $('.bundle-builder-widget').removeClass('four');
      $('.modal__action-buttons .button--next').removeClass('hide');
      $('.modal__action-buttons .button-bundle-widget-addtocart').addClass('hide');
      $modalWidget.find('.cart__headings').removeClass('hide');
      if(checkDiscountTimer()) {
        $('.modal__title p').text('');
      }
    }
  })

  // Modal Footer Action Buttons End

  /** STEP zero **/

  // Select a product on Step Zero
  $('.modal__step--zero .product__container').on('click', (e) => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    $('.modal__step--zero .product__container').removeClass('selected');
    $this.addClass('selected');
    const p_handle = $this.find('h4').data('url');

    if (p_handle && p_handle != '') {
      window.location.href = p_handle;
    }else{
      alert("Please select at least one bundle!");
      return;
    }

  });

  /** STEP 1 **/
  // Step 1 Member Dropdown option change Event
  $('.member__type .member__quantity .quantity-minus').on('click', (e) => {
    const $this = $(e.currentTarget);
    const $input = $this.closest('.member__quantity').find('.quantity-input');
    const val = parseInt($input.val());

    if(val > 0){
     $this.attr('disabled', false);
    }
  });

  $('.member__type .member__quantity .quantity-minus, .member__type .member__quantity .quantity-plus').on('click', (e) => {
    const $this = $(e.currentTarget);
    const optionInputs = $modalWidget.find('.bundle-builder-input');
    let all_empty = true;
    setTimeout(function(){
      Array.from(optionInputs).forEach(element => {
        if($(element).val() > 0 ) all_empty = false;
      })

      if(all_empty) {
        $modalWidget.find('.button--next').addClass('disabled');
      }else{
        $modalWidget.find('.button--next').removeClass('disabled');
      }
      if (!firstLevelDiscountOut && !disableDiscount) {
        renderItemsInfo();
      }
    }, 100);
  })

  const renderItemsInfo = () => {
    selectedVariantOptions = [];
    const memberTypes = $('.member__profile');
    Array.from(memberTypes).forEach(element => {
      const count = $(element).find('.bundle-builder-input').val();
      for(var i = 0; i < count; i++) {
        selectedVariantOptions.push(element)
      }
    })

    const isDiscountTimer = checkDiscountTimer();

    // Calculating main products count
    let main_product_count = selectedVariantOptions.length;

    const main_product_discount = calMainDiscount(main_product_count);

    let saved_percentage_msg = "You've saved 10%!";
    let more_save_msg = '';

    if(main_product_discount == 0.9){
        more_save_msg = `Want more savings? Add ${4 - main_product_count} more ${(4 - main_product_count) > 1 ? `books` : `book`} to save 20%! `;
    }else if(main_product_discount == 0.80){
        saved_percentage_msg = "You've saved 20%!";
    }else{
        more_save_msg = `Want more savings? Add ${2 - main_product_count} more ${(2 - main_product_count) > 1 ? `books` : `book`} to save 10%! `;
        saved_percentage_msg = "";
    }
    if(!isDiscountTimer) $('.modal__title p').text(more_save_msg);
    if(!isDiscountTimer) $('.modal__title span').text(saved_percentage_msg);

    // Cluster all product variants
    variantOptionsAll = [];
    const memberTypesAll = $('.modal__step--one .member__profile');
    Array.from(memberTypes).forEach(element => {
      const productPrice = $(element).data('price');
      const discount_price = ((productPrice / 100) * main_product_discount).toFixed(2);
      const productPriceContainer = $(element).find(".member__price");
      productPriceContainer.text( `$${discount_price}`);
    });
  }

  // Listen Cart screen Qty input field change
  $(document).on('keyup keydown change', '.member__type .quantity-input.bundle-builder-input', function (e) {
    const optionInputs = $modalWidget.find('.bundle-builder-input');
    let all_empty = true;
    setTimeout(function(){
      Array.from(optionInputs).forEach(element => {
        if($(element).val() > 0 ) all_empty = false;
      })

      if(all_empty) {
        $modalWidget.find('.button--next').addClass('disabled');
      }else{
        $modalWidget.find('.button--next').removeClass('disabled');
      }
    }, 100);
  });

  /** STEP 2 **/
  //Render variants of a selected product on Step 2
  const renderProducts = (product) => {
    if(product) {

      const variants = product.variants;

      let filteredVariants = variants.map(variant => {
        item = selectedVariantOptions.find(item => variant.option1.includes(item));
        if (item && variant.available) {
          return variant;
        }
      }).filter(item => item !== undefined); // Can also use filter(item => item);

      const copyFilteredVariants = [...filteredVariants];
      const medias = product.media;
      const filteredVariantsWithMedia = copyFilteredVariants.map(variant => {
        item_prek = medias.find(item_prek => (item_prek.alt && item_prek.alt.includes('IMAGE-PREK')))
        item_primary = medias.find(item_primary => (item_primary.alt && item_primary.alt.includes('IMAGE-PRIMARY')))
        item_junior = medias.find(item_junior => (item_junior.alt && item_junior.alt.includes('IMAGE-JUNIOR')))
        item_youth = medias.find(item_youth => (item_youth.alt && item_youth.alt.includes('IMAGE-YOUTH')))
        item_parent = medias.find(item_parent => (item_parent.alt && item_parent.alt.includes('IMAGE-PARENT')))

        if (variant.option1.includes("PRE-K")) {
          if(item_prek){
            variant.variant_img = item_prek;
          }else{
            variant.variant_img = product.featured_image;
          }
          return variant;
        }
        if (variant.option1.includes("PRIMARY")) {
          if(item_primary){
            variant.variant_img = item_primary;
          }else{
            variant.variant_img = product.featured_image;
          }
          return variant;
        }
        if (variant.option1.includes('JUNIOR')) {
          if(item_junior){
            variant.variant_img = item_junior;
          }else{
            variant.variant_img = product.featured_image;
          }
          return variant;
        }
        if (variant.option1.includes('YOUTH')) {
          if(item_youth){
            variant.variant_img = item_youth;
          }else{
            variant.variant_img = product.featured_image;
          }
          return variant;
        }
        if (variant.option1.includes('PARENT')) {
          if(item_parent){
            variant.variant_img = item_parent;
          }else{
            variant.variant_img = product.featured_image;
          }
          return variant;
        }
      }).filter(item => item !== undefined); // Can also use filter(item => item);

      let variantsOutput = "";

      let widthClass = "";
      if(filteredVariantsWithMedia.length == 1) {
        widthClass = "one";
      }else if(filteredVariantsWithMedia.length == 2){
        widthClass = "two";
      }else if(filteredVariantsWithMedia.length >= 3){
        widthClass = "three";
      }else{
        widthClass = "default";
      }

      const prek_desc = $modalWidget.data('prek-desc');
      const primary_desc = $modalWidget.data('primary-desc');
      const junior_desc = $modalWidget.data('junior-desc');
      const youth_desc = $modalWidget.data('youth-desc');
      const parent_desc = $modalWidget.data('parent-desc');

      variantsOutput = filteredVariantsWithMedia.map((variant, index) => {
        const { available, name, title, price, id, variant_img } = variant;
        let price_with_currency = `$${(price / 100).toFixed(2)}`;
        const variant_count = selectedVariantOptions.filter(x => variant.option1.includes(x)).length;

        let description = '';
        if(name.includes('PRIMARY')) {
          description = primary_desc;
        }else if(name.includes('JUNIOR')) {
          description = junior_desc;
        }else if(name.includes('PRE-K')) {
          description = prek_desc;
        }else if(name.includes('YOUTH')) {
          description = youth_desc;
        }else if(name.includes('PARENT')) {
          description = parent_desc;
        }
        return `
          ${
            available ?
            `<div class="product__thumbnail row--${widthClass} selected"
              data-id="${id}"
              data-value="${variant.option1}"
              data-product-id="${product.id}"
              data-title="${name}"
              data-img="${variant_img ? variant_img.src : ''}"
              data-price="${price}"
            >
              <div class="badge-wrapper"><div class="count-badge">x${variant_count}</div></div>
              <div class="product-image__wrapper">
                <div class="image-element__wrap">
                  <img alt="" class="transition--none lazyautosizes lazyloaded" src="${variant_img ? variant_img.src : ''}">
                </div>
              </div>
              <div class="thumbnail__caption text-align-left">
                <div class="product-thumbnail">
                  <span class="product-thumbnail__title">${title}</span>
                  <div class="product-thumbnail__description">
                  ${description != "" ?
                  `<ul class="product-thumbnail__desc">${description}</ul>` :
                  ``}
                  </div>
                </div>
              </div>
            </div>`:
            ``
          }
        `;
      }).join("");

      $('.modal__step--two').html('');
      $('.modal__step--two').html(variantsOutput);

      const $variantsSlider = $('[data-recommended-variants-slider]');
      if(filteredVariantsWithMedia.length > 3 ){
        if ( matchMedia('screen and (min-width: 769px)').matches ) {
          $variantsSlider.flickity({
            pageDots: false,
            imagesLoaded: true,
            draggable: true,
            cellAlign: 'left',
            adaptiveHeight: false,
            arrowShape: {
              x0: 10,
              x1: 60, y1: 50,
              x2: 70, y2: 40,
              x3: 30
            }
          });

          setTimeout(function(){
            $variantsSlider.flickity('reposition');
          }, 100);
        }

      }
      $modalWidget.find('.overlay').hide();
    }else{
      $modalWidget.find('.overlay').hide();
    }
  }


  /** STEP 4 **/
  // Render Addons of a selected product on Step 4
  const renderAddons = (addons) => {

    let addonsOutput = "";

    let widthClass = "";
    if(addons.length == 1) {
      widthClass = "one";
    }else if(addons.length == 2){
      widthClass = "two";
    }else if(addons.length >= 3){
      widthClass = "three";
    }else{
      widthClass = "default";
    }
    addonsOutput = addons.map(addon => {
      const { available, title, description, price, id, featured_image } = addon;
      const variants = addon.variants;
      const variant_id = variants[0].id;

      let price_with_currency = `$${(price / 100).toFixed(2)}`;
      let filtered_desc = description.replace(/<[^>]*>?/gm, '');
      if(filtered_desc.includes('&lt;/bundle_desc&gt;')) {
        const filtered = filtered_desc.split('&lt;/bundle_desc&gt;');
        if(filtered && filtered.length > 0) filtered_desc = filtered[0];
      }
      return `
        ${
          available ?
          `<div class="product__thumbnail row--${widthClass}"
            data-variant-id="${variant_id}"
            data-title="${title}"
            data-img="${!featured_image ? product.featured_image : featured_image}"
            data-price="${price}"
          >
          <div class="badge-wrapper"><div class="count-badge">✓</div></div>
            <div class="product-image__wrapper">
              <div class="image-element__wrap">
                ${
                  !featured_image ?
                  `<img alt="" class="transition--none lazyautosizes lazyloaded" src="${product.featured_image}">` :
                  `<img alt="" class="transition--none lazyautosizes lazyloaded" src="${featured_image}">`
                }
              </div>
            </div>
            <div class="thumbnail__caption text-align-left">
              <div class="product-thumbnail">
                <span class="product-thumbnail__title">${title}</span>
                <span class="product-thumbnail__price money price">
                  <span class="money">${price_with_currency}</span>
                </span>
                <div class="product-thumbnail__description">
                ${filtered_desc != "" ?
                `<span class="product-thumbnail__desc">${filtered_desc}</span>`:
                ``}
              </div>
              </div>
            </div>
          </div>`:
          ``
        }
      `;
    }).join("");

    $('.modal__step--three').html('');
    $('.modal__step--three').html(addonsOutput);
    $modalWidget.find('.overlay').hide();
  }

  // Click event for product
  $(document).on('click', '.modal__step--three .product__thumbnail', (e) => {
    const $this = $(e.currentTarget);
    $this.toggleClass('selected');
  })


  const getDiscountMessages = (count) => {
    if(count >=2 && count < 5){

    }
  }

  //Final Step, rendering bundle items
  const renderCartItems = () => {
    const isDiscountTimer = checkDiscountTimer();
    if(selectedProductInfo.length < 1) {
      $('.modal__step--four .cart__body').html('');
      $modalWidget.find('.overlay').hide();
      $('.modal__action-buttons .button-bundle-widget-addtocart').addClass('hide');
      $modalWidget.find('.cart__headings').addClass('hide');
      $modalWidget.find('.modal__title p').text(getActiveSubTitle('empty_cart'));
      $('.bundle-builder-widget').removeClass('four');
      return;
    }

    // Calculating main products count
    let main_product_count = 0;
    selectedProductInfo.map(x => {
      if(!x.addOn){
        main_product_count += x.qty;
      }
    })
    
    const main_product_discount = calMainDiscount(main_product_count);

    let saved_percentage_msg = "You've saved 10%!";
    let more_save_msg = '';
    let total_saved_price = 0;
    let total_normal_price = 0;
    let total_discounted_price = 0;

    if (!firstLevelDiscountOut || !disableDiscount) {
      if (main_product_discount == 0.9) {
        more_save_msg = `Want more savings? Add ${4 - main_product_count} more ${(4 - main_product_count) > 1 ? `books` : `book`} to save 20%! `;
      } else if (main_product_discount == 0.80) {
        saved_percentage_msg = "You've saved 20%!";
      } else {
        more_save_msg = `Want more savings? Add ${2 - main_product_count} more ${(2 - main_product_count) > 1 ? `books` : `book`} to save 10%! `;
        saved_percentage_msg = "";
      }
    }

    if(!isDiscountTimer) $('.modal__title p').text(more_save_msg);

    let itemOutput = selectedProductInfo.map(product => {
      if (firstLevelDiscountOut || disableDiscount) {
        const { img, title, price, qty, id, addOn } = product;
        let discount_price = 0;
        let old_price = (price * qty / 100).toFixed(2);
        if (addOn && !disableDiscount) {
          saved_percentage_msg = "You've saved 10%!";
          discount_price = ((price * qty / 100) * 0.9).toFixed(2);

          total_normal_price += Number(old_price);
          total_saved_price += Number(old_price - discount_price);
          total_discounted_price += Number(discount_price);
          return `
          ${
            qty > 0 ?
            `
            <div class="cart__card container is-align-center" data-variant-id="${id}">
              <div class="cart__image">
                <div class="image-element__wrap">
                  <img alt="" class="transition--none lazyautosizes lazyloaded" src="${img}">
                </div>
              </div>
              <div class="cart__info">
                <div class="cart__description">
                  <div class="cart__text">
                    <p class="item__title">
                      ${title}
                    </p>
                  </div>
                </div>
                <div class="product-quantity-box quantity-wrapper field has-addons quantity-style--box is-medium">
                  <div class="control minus-control">
                    <span class="bundle-quantity-btn quantity-minus quantity-element is-inverse" data-update-quantity="minus" ${qty == 0 ? `disabled` : ''} data-variant-id="${id}">
                      <span class="icon " data-icon="down-caret">
                      <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.88574 1.91138H12.2149" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                      </svg>
                      </span>
                    </span>
                  </div>
                  <div class="control quantity-input-control quantity-input-control--fill">
                    <input class="bundle-quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${qty}" data-variant-id="${id}"/>
                  </div>
                  <div class="control plus-control">
                    <span class="bundle-quantity-btn quantity-plus quantity-element is-inverse" data-update-quantity="plus" data-variant-id="${id}">
                      <span class="icon " data-icon="up-caret">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.88574 7H12.2149" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                        <path d="M7.05029 12.1646L7.05029 1.83544" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                      </svg>                  </span>
                    </span>
                  </div>
                </div>

                <div class="cart__price">
                  ${!isDiscountTimer ?
                    `
                    <p class="sale">
                      <span class="money">$${discount_price}</span>
                    </p>
                    <s class="original-price">
                      <span class="money"> $${old_price}</span>
                    </s>
                    ` :
                    `
                    <p class="sale">
                      <span class="money">$${old_price}</span>
                    </p>
                    `
                  }

                  ${!isDiscountTimer ?
                    `
                    <div class="line-item-discount__container">
                      <p>${saved_percentage_msg}</p>
                    </div>
                    `:
                  ``
                  }

                </div>
                <div class="cart__remove">
                <div class="cart__remove-btn is-inline-flex is-align-center is-justify-center ajax-cart__delete" data-variant-id="${id}" title="Remove">
                  <button class="close" aria-label="close">
                    <span class="icon " data-icon="x">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 4.5V18H15.7406V4.5H2.25ZM5.99693 15C5.99693 15.414 5.66093 15.75 5.24693 15.75C4.83293 15.75 4.49693 15.414 4.49693 15V7.5C4.49693 7.086 4.83293 6.75 5.24693 6.75C5.66093 6.75 5.99693 7.086 5.99693 7.5V15ZM9.74431 15C9.74431 15.414 9.40831 15.75 8.99431 15.75C8.58031 15.75 8.24431 15.414 8.24431 15V7.5C8.24431 7.086 8.58031 6.75 8.99431 6.75C9.40831 6.75 9.74431 7.086 9.74431 7.5V15ZM13.4917 15C13.4917 15.414 13.1557 15.75 12.7417 15.75C12.3277 15.75 11.9917 15.414 11.9917 15V7.5C11.9917 7.086 12.3277 6.75 12.7417 6.75C13.1557 6.75 13.4917 7.086 13.4917 7.5V15ZM16.4896 1.5V3H1.5V1.5H5.78027C6.45481 1.5 7.00267 0.67575 7.00267 0H10.9862C10.9862 0.67575 11.5333 1.5 12.2086 1.5H16.4896Z" fill="#939598"/>
                    </svg>
                    </span>
                  </button>
                </div>
              </div>
              </div>
            </div>
            ` :
            ``
          }
          `
        } else {
          total_discounted_price += Number(old_price);
          total_normal_price += Number(old_price);
          return `
          ${
            qty > 0 ?
            `
            <div class="cart__card container is-align-center" data-variant-id="${id}">
              <div class="cart__image">
                <div class="image-element__wrap">
                  <img alt="" class="transition--none lazyautosizes lazyloaded" src="${img}">
                </div>
              </div>
              <div class="cart__info">
                <div class="cart__description">
                  <div class="cart__text">
                    <p class="item__title">
                      ${title}
                    </p>
                  </div>
                </div>
                <div class="product-quantity-box quantity-wrapper field has-addons quantity-style--box is-medium">
                  <div class="control minus-control">
                    <span class="bundle-quantity-btn quantity-minus quantity-element is-inverse" data-update-quantity="minus" ${qty == 0 ? `disabled` : ''} data-variant-id="${id}">
                      <span class="icon " data-icon="down-caret">
                      <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.88574 1.91138H12.2149" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                      </svg>
                      </span>
                    </span>
                  </div>
                  <div class="control quantity-input-control quantity-input-control--fill">
                    <input class="bundle-quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${qty}" data-variant-id="${id}"/>
                  </div>
                  <div class="control plus-control">
                    <span class="bundle-quantity-btn quantity-plus quantity-element is-inverse" data-update-quantity="plus" data-variant-id="${id}">
                      <span class="icon " data-icon="up-caret">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.88574 7H12.2149" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                        <path d="M7.05029 12.1646L7.05029 1.83544" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                      </svg>                  </span>
                    </span>
                  </div>
                </div>

                <div class="cart__price">
                  ${!isDiscountTimer ?
                    `
                    <p>
                      <span class="money"> $${old_price}</span>
                    </p>
                    ` :
                    `
                    `
                  }
                </div>
                <div class="cart__remove">
                <div class="cart__remove-btn is-inline-flex is-align-center is-justify-center ajax-cart__delete" data-variant-id="${id}" title="Remove">
                  <button class="close" aria-label="close">
                    <span class="icon " data-icon="x">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 4.5V18H15.7406V4.5H2.25ZM5.99693 15C5.99693 15.414 5.66093 15.75 5.24693 15.75C4.83293 15.75 4.49693 15.414 4.49693 15V7.5C4.49693 7.086 4.83293 6.75 5.24693 6.75C5.66093 6.75 5.99693 7.086 5.99693 7.5V15ZM9.74431 15C9.74431 15.414 9.40831 15.75 8.99431 15.75C8.58031 15.75 8.24431 15.414 8.24431 15V7.5C8.24431 7.086 8.58031 6.75 8.99431 6.75C9.40831 6.75 9.74431 7.086 9.74431 7.5V15ZM13.4917 15C13.4917 15.414 13.1557 15.75 12.7417 15.75C12.3277 15.75 11.9917 15.414 11.9917 15V7.5C11.9917 7.086 12.3277 6.75 12.7417 6.75C13.1557 6.75 13.4917 7.086 13.4917 7.5V15ZM16.4896 1.5V3H1.5V1.5H5.78027C6.45481 1.5 7.00267 0.67575 7.00267 0H10.9862C10.9862 0.67575 11.5333 1.5 12.2086 1.5H16.4896Z" fill="#939598"/>
                    </svg>
                    </span>
                  </button>
                </div>
              </div>
              </div>

            </div>
            ` :
            ``
          }
        `
        }
      } else {
        const { img, title, price, qty, id, addOn } = product;
        let discount_price = 0;
        let old_price = (price * qty / 100).toFixed(2);
        if (addOn) {
          saved_percentage_msg = "You've saved 10%!";
          discount_price = ((price * qty / 100) * 0.9).toFixed(2)
        } else {
          discount_price = ((price * qty / 100) * main_product_discount).toFixed(2)
        }
        total_normal_price += Number(old_price);
        total_saved_price += Number(old_price - discount_price);
        total_discounted_price += Number(discount_price);
        return `
        ${
          qty > 0 ?
          `
          <div class="cart__card container is-align-center" data-variant-id="${id}">
            <div class="cart__image">
              <div class="image-element__wrap">
                <img alt="" class="transition--none lazyautosizes lazyloaded" src="${img}">
              </div>
            </div>
            <div class="cart__info">
              <div class="cart__description">
                <div class="cart__text">
                  <p class="item__title">
                    ${title}
                  </p>
                </div>
              </div>
              <div class="product-quantity-box quantity-wrapper field has-addons quantity-style--box is-medium">
                <div class="control minus-control">
                  <span class="bundle-quantity-btn quantity-minus quantity-element is-inverse" data-update-quantity="minus" ${qty == 0 ? `disabled` : ''} data-variant-id="${id}">
                    <span class="icon " data-icon="down-caret">
                    <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.88574 1.91138H12.2149" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                    </svg>
                    </span>
                  </span>
                </div>
                <div class="control quantity-input-control quantity-input-control--fill">
                  <input class="bundle-quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${qty}" data-variant-id="${id}"/>
                </div>
                <div class="control plus-control">
                  <span class="bundle-quantity-btn quantity-plus quantity-element is-inverse" data-update-quantity="plus" data-variant-id="${id}">
                    <span class="icon " data-icon="up-caret">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.88574 7H12.2149" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                      <path d="M7.05029 12.1646L7.05029 1.83544" stroke="black" stroke-width="2.43038" stroke-linecap="square"/>
                    </svg>                  </span>
                  </span>
                </div>
              </div>


              <div class="cart__price">
                ${!isDiscountTimer ?
                  `
                  <p class="sale">
                    <span class="money">$${discount_price}</span>
                  </p>
                  <s class="original-price">
                    <span class="money"> $${old_price}</span>
                  </s>
                  ` :
                  `
                  <p class="sale">
                    <span class="money">$${old_price}</span>
                  </p>
                  `
                }

                ${!isDiscountTimer ?
                  `
                  <div class="line-item-discount__container">
                    <p>${saved_percentage_msg}</p>
                  </div>
                  `:
                ``
                }

              </div>
              <div class="cart__remove">
              <div class="cart__remove-btn is-inline-flex is-align-center is-justify-center ajax-cart__delete" data-variant-id="${id}" title="Remove">
                <button class="close" aria-label="close">
                  <span class="icon " data-icon="x">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 4.5V18H15.7406V4.5H2.25ZM5.99693 15C5.99693 15.414 5.66093 15.75 5.24693 15.75C4.83293 15.75 4.49693 15.414 4.49693 15V7.5C4.49693 7.086 4.83293 6.75 5.24693 6.75C5.66093 6.75 5.99693 7.086 5.99693 7.5V15ZM9.74431 15C9.74431 15.414 9.40831 15.75 8.99431 15.75C8.58031 15.75 8.24431 15.414 8.24431 15V7.5C8.24431 7.086 8.58031 6.75 8.99431 6.75C9.40831 6.75 9.74431 7.086 9.74431 7.5V15ZM13.4917 15C13.4917 15.414 13.1557 15.75 12.7417 15.75C12.3277 15.75 11.9917 15.414 11.9917 15V7.5C11.9917 7.086 12.3277 6.75 12.7417 6.75C13.1557 6.75 13.4917 7.086 13.4917 7.5V15ZM16.4896 1.5V3H1.5V1.5H5.78027C6.45481 1.5 7.00267 0.67575 7.00267 0H10.9862C10.9862 0.67575 11.5333 1.5 12.2086 1.5H16.4896Z" fill="#939598"/>
                  </svg>
                  </span>
                </button>
              </div>
            </div>
            </div>


          </div>
          ` :
          ``
        }
        `
      }
    }).join("");

    $('.modal__step--four .cart__body').html('');
    if(!isDiscountTimer) { //Only Apply the discount if Discount Timer isn't running at this moment.
      if (!disableDiscount) {
        $('.bundle-builder-widget .cart__footer .saved-text').text(`You've saved $${total_saved_price.toFixed(2)}!`);
      }

      $('.bundle-builder-widget .cart__footer .total-price').text(`Total: $${total_discounted_price.toFixed(2)}`);
    }else{
      $('.modal__title p').text('');
      $('.bundle-builder-widget .cart__footer .saved-text').text('');
      $('.bundle-builder-widget .cart__footer .total-price').text(`Total: $${total_normal_price.toFixed(2)}`);
    }

    $('.modal__step--four .cart__body').html(itemOutput);
    $modalWidget.find('.overlay').hide();
  }

  // Listen remove button on cart page
  $(document).on('click', '.modal__step--four .cart__remove-btn', (e) => {
    const $this = $(e.currentTarget);
    const variantId = $this.data('variant-id');
    const filteredResult = selectedProductInfo.filter(function(v) { return v.id !== variantId; });

    if(filteredResult){
      const removedCartItem = $this.closest('.cart__card');
      removedCartItem.remove();
      selectedProductInfo = [...filteredResult];
    }
    setTimeout(function(){
      renderCartItems();
    }, 0);

  })

  // Listen Cart screen Qty input field change
  $(document).on('keyup keydown change', '.modal__step--four .cart__info .bundle-quantity-input', function (e) {
    const $this = $(e.currentTarget);
    const currentVal = parseInt($this.val());
    const variantId = $this.data('variant-id');
    // update quantity of product bundle array
    updateQuantity(variantId, currentVal);
  });

  // Listen Cart Screen Qty Plus/Minus Click event
  $(document).on('click', '.modal__step--four .bundle-quantity-btn', (e) => {
    const $this = $(e.currentTarget);
    const $quantityWrapper = $this.closest('.quantity-wrapper');
    const $input = $quantityWrapper.find('.quantity-input-control .bundle-quantity-input');
    const currentVal = parseInt($input.val());
    const variantId = $this.data('variant-id');
    let nextVal = 0;
    if($this.hasClass('quantity-minus')){
      //minus
      if(currentVal == 0) return;
      nextVal = currentVal - 1;
      $input.val(nextVal);
    }else{
      //plus
      nextVal = currentVal + 1;
      $input.val(nextVal);
    }
    // update quantity of product bundle array
    updateQuantity(variantId, nextVal);

  })

  if(isStepZero()) {
    $('.bundle-builder-widget').addClass('zero');
    $modalWidget.find('.modal__header .modal__step').hide();
    $modalWidget.find('.modal__title h2').text(getActiveTitle('topic'));
    $modalWidget.find('.modal__title p').text('');
    $modalWidget.find('.modal__step--zero .product__container').eq(0).addClass('selected')
  }else{
    $modalWidget.find('.modal__title h2').text(getActiveTitle('family'));
    $modalWidget.find('.modal__title p').text(getActiveSubTitle('family'));
  }


  // Bundle Cart QTY functions.
  const updateBundleQuantity = ($el) => {
    var $quantityBox = $el.parents('.product-quantity-box');
    var $input = $('.box-quantity-input', $quantityBox);
    var boxId =  $el.data('box-id');
    var val = parseInt($input.val());
    var valMax = 100000000000000000;
    var valMin = $input.attr('min') || 0;

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (isNaN(val) || val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }

    if ($el.data('update-bundle-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-bundle-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    } // Update quantity if within cart (vs on the product page)

    if (boxId) {
      createBundleCartItems(boxId, val);
    } // Call to update quantity controls

    updateBundleQuantityControls($el);
  }

  const updateBundleQuantityControls = ($el) => {
    var $quantityBox = $el.parents('.product-quantity-box');
    var $input = $('.box-quantity-input', $quantityBox);
    var val = parseInt($input.val());
    var valMax = 100000000000000000;

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
  }

  const createBundleCartItems = (boxId, qty) => {
		let data = {
			'updates': {}
		}

    $.getJSON('/cart.js').done((cart) => {
			const boxArr = cart.items.filter(item => item.properties._boxId == boxId);

			boxArr.forEach((item) => {
        const initialQty = item.properties["_bundle_initial_qty"];
        const initialQtyInt = parseInt(initialQty) || 1;
        const quantity = initialQtyInt * qty;
				data['updates'][item.key] = quantity;
			});

			updateBoxItems(data, boxId);
		});
	}

  const updateBoxItems = (data, boxId) => {

    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(data) {
          resolve(data);
          if (data.item_count >= 0) {

            // Cart page and Minicart Update Start

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: 'html',
                url: "/cart",
                success: function (html) {
                  const bundleItems = data.items.find(item => item.properties._boxId == boxId);
                  if(!bundleItems) {
                    $("[data-box-placeholder=\"".concat(boxId, "\"]")).remove();
                  }
                  var itemTotal = $(html).find("[data-box-placeholder=\"".concat(boxId, "\"]")).find('.cart__total');
                  var quantityInput = $(html).find("[data-box-placeholder=\"".concat(boxId, "\"]")).find('.box-quantity-input');
                  var itemPrice = $(html).find("[data-box-placeholder=\"".concat(boxId, "\"]")).find('.cart__price');
                  var boxChildItems = $(html).find("[data-box-child-items=\"".concat(boxId, "\"]"))

                  $("[data-box-placeholder=\"".concat(boxId, "\"]")).find('.cart__total').replaceWith(itemTotal);
                  $("[data-box-placeholder=\"".concat(boxId, "\"]")).find('.box-quantity-input').replaceWith(quantityInput);
                  $("[data-box-placeholder=\"".concat(boxId, "\"]")).find('.cart__price').replaceWith(itemPrice);
                  $("[data-box-child-items=\"".concat(boxId, "\"]")).replaceWith(boxChildItems);

                  var subtotal = $(html).find('.cart__subtotal-container');
                  var discounts = $(html).find('.cart__discounts');
                  var savings = $(html).find('.cart__total-savings');
                  $('.cart__subtotal-container').replaceWith(subtotal);

                  if (discounts.length > 0 && $('.cart__discounts').length < 1) {
                    $('.cart__subtotal-container').before(discounts);
                  } else {
                    $('.cart__discounts').replaceWith(discounts);
                  }

                  if (savings.length > 0 && $('.cart__total-savings').length < 1) {
                    $('.cart__subtotal-container').after(savings);
                  } else {
                    $('.cart__total-savings').replaceWith(savings);
                  }

                  $('[data-bind="itemCount"]').text(data.item_count);
                }
              });
            // Cart page Minicart Update End

          } else {
            $('.cart__empty-cart-message').removeClass('is-hidden');
            $('.cart__form').addClass('is-hidden');
            $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
            $('[data-bind="itemCount"]').text('0');
          }

          window.PXUTheme.asyncView.load(
            window.PXUTheme.routes.cart_url, // template name
            'ajax', // view name (suffix)
          ).done(function (_ref3) {
              var html = _ref3.html,
                  options = _ref3.options;

                if (options.item_count > 0) {
                  const itemList = $(html.content).find('.ajax-cart__list');
                  const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

                  $('.ajax-cart__list').replaceWith(itemList);
                  $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
                  $('.ajax-cart__empty-cart-message').addClass('is-hidden');
                  $('.ajax-cart__form').removeClass('is-hidden');
                  $('[data-ajax-cart-trigger]').addClass('has-cart-count');
                  $('[data-bind="itemCount"]').text(options.item_count);

                } else {
                  $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
                  $('.ajax-cart__form').addClass('is-hidden');
                  $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
                  $('[data-bind="itemCount"]').text('0');
                }

                if (window.PXUTheme.currencyConverter) {
                  window.PXUTheme.currencyConverter.convertCurrencies();
                }
            }).fail(function () {// some error handling
            });
          }
        }
      });
    });
  };

  const removeBundleFromCart = (bodId) => {
    createBundleCartItems(bodId, 0)
  }

  $(document).on('click', '[data-update-bundle-quantity]:not([disabled])', function(evt) {
    evt.preventDefault();
    updateBundleQuantity($(this));
  })

  $(document).on('keyup keydown change', '.box-quantity-input', function(evt) {
    updateBundleQuantity($(this));
  })

  $(document).on('click', '[data-bundle-cart-page-delete]', function (e) {
    e.preventDefault();
    var bodId = $(this).data('box-id');
    removeBundleFromCart(bodId);
    return false;
  }); // Prevent the ajax cart form from being submitted when pressing the "Enter" key


});
